import * as React from "react";
import { BaseSVG } from "../../BaseSVG";

export const QuickSpinIcon = props => (
  <BaseSVG viewBox="0 0 38 38" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-327.000000, -380.000000)">
        <g transform="translate(327.000000, 380.000000)">
          <g>
            <g
              transform="translate(9.333333, 12.000000)"
              fill="currentColor"
              fillRule="nonzero"
            >
              <polygon points="12 15 22 7.5 12 0" />
              <polygon points="0 15 10 7.5 0 0" />
            </g>
            <circle
              stroke="currentColor"
              strokeWidth="3"
              cx="19"
              cy="19"
              r="17.5"
            />
          </g>
        </g>
      </g>
    </g>
  </BaseSVG>
);
